import { create } from 'zustand';
import { getUsage, type UsageResponse } from '../api/usage.js';
import { useAuthStore } from './authStore.js';

interface UsageState {
  data: UsageResponse | null;
  loading: boolean;
  error: string | null;

  /** Carga inicial. Llamar al hidratar la sesión. */
  refresh: () => Promise<void>;
  /** Limpia el cache (al logout o switch tenant). */
  clear: () => void;
}

export const useUsageStore = create<UsageState>((set, get) => ({
  data: null,
  loading: false,
  error: null,

  refresh: async () => {
    // El invitado del sitio demo no tiene medidor de consumo, así que pedirlo le
    // devuelve 403. La guarda vive acá y no en cada llamador: son ocho —el
    // presupuesto entre ellos— y basta que uno se olvide para que el invitado
    // vuelva a pegarle a una ruta que no le corresponde.
    if (useAuthStore.getState().demoGuest) return;
    if (get().loading) return;
    set({ loading: true, error: null });
    try {
      const data = await getUsage();
      set({ data, loading: false });
    } catch (err) {
      set({ loading: false, error: (err as Error).message });
    }
  },

  clear: () => set({ data: null, loading: false, error: null }),
}));

/**
 * Helper para refrescar el consumo después de operaciones que incrementan
 * contadores (crear proyecto, mandar chat, terminar cotización). No
 * bloquea — falla silenciosa.
 */
export function refreshUsageSoon(): void {
  void useUsageStore.getState().refresh();
}
